import React from "react";
import { Loader2 } from "lucide-react";

const PASTEL = ["bg-sky-100", "bg-pink-100", "bg-yellow-100", "bg-emerald-100"];

export const ProductSkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white border-4 border-slate-900 rounded-3xl overflow-hidden cartoon-shadow">
        <div className={`aspect-square ${PASTEL[i % PASTEL.length]} border-b-4 border-slate-900 animate-pulse`} />
        <div className="p-5 space-y-3">
          <div className="h-5 bg-slate-200 rounded animate-pulse" />
          <div className="h-4 bg-slate-200 rounded w-3/4 animate-pulse" />
          <div className="h-8 bg-slate-200 rounded animate-pulse" />
        </div>
      </div>
    ))}
  </div>
);

export const Spinner = () => (
  <div className="flex items-center justify-center py-20">
    <Loader2 className="w-10 h-10 animate-spin text-sky-500" />
  </div>
);
